import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Stars from "react-stars";
import { replaceParams } from "core/utils";
import { colors } from "core/stylesheet";
import { candidate } from "routes/paths";
import { push } from "react-router-redux";
import { Container } from "components/generic/layout";
import { BoxSpinner, Button, Status } from "components/generic/kit";
import { Overlay } from "components/common/candidate";
import * as model from "modules/booking/model";

const StyledLink = styled(Link)`
  color: ${colors.brand};
`;

const Row = ({ title, value }) => (
  <div className="flex mb1">
    <div className="fw6">{title}</div>
    <div className="ml-auto">{value}</div>
  </div>
);

export default ({ call, isLoading, dispatch, feedback, selfFeedback }) => {
  if (isLoading) {
    return (
      <Overlay>
        <Container>
          <BoxSpinner />;
        </Container>
      </Overlay>
    );
  }

  const params = { id: call.insider.id };
  const checkoutQuery = `?bookingId=${call.id}`;
  const rescheduleQuery = `?booking_id=${call.id}&time_start=${call.date}`;

  return (
    <Overlay>
      <Container>
        <div className="pv5">
          <div className="fw6 mb3 flex items-center">
            Call overview
            {!call.is_expired &&
              !call.to_be_paid && (
                <div className="ml-auto">
                  <div className="mr2-ns dib">
                    <Button
                      color="white"
                      size="responsive"
                      onClick={() =>
                        dispatch(
                          push(
                            replaceParams(candidate.reschedule, params) +
                              rescheduleQuery
                          )
                        )
                      }
                    >
                      Reschedule
                    </Button>
                  </div>
                  <Button
                    size="responsive"
                    color="brand"
                    onClick={() =>
                      dispatch(
                        push(
                          replaceParams(candidate.cancelCall, params) +
                            rescheduleQuery
                        )
                      )
                    }
                  >
                    Cancel
                  </Button>
                </div>
              )}
            {call.to_be_paid && (
              <div className="ml-auto">
                <div className="mr2-ns dib">
                  <Button
                    color="white"
                    size="responsive"
                    onClick={() =>
                      dispatch(
                        push(
                          replaceParams(candidate.pay, params) + checkoutQuery
                        )
                      )
                    }
                  >
                    Go to Checkout
                  </Button>
                </div>
                <Button
                  size="responsive"
                  onClick={() =>
                    dispatch(
                      push(
                        replaceParams(candidate.cancelCall, params) +
                          rescheduleQuery
                      )
                    )
                  }
                >
                  <div className="fw6">Cancel</div>
                </Button>
              </div>
            )}
          </div>
          <div className="bg-white pa3 br2 f6">
            <div className="flex flex-column flex-row-ns">
              <div className="w-50-ns pr3-ns">
                <Row title="Status:" value={<Status>{call.status}</Status>} />
                <Row title="Date:" value={model.formatTime(call.date)} />
                <Row
                  title="Insider:"
                  value={
                    <StyledLink
                      className="fw6"
                      to={replaceParams(candidate.insiderProfile, params)}
                    >
                      {call.insider.name}
                    </StyledLink>
                  }
                />
                <Row title="Company:" value={call.insider.company} />
                <Row title="Duration:" value={call.duration + " minutes"} />
                <Row title="Price:" value={"$" + call.price} />
              </div>
              <div className="w-50-ns pl3-ns">
                <div className="mb1">
                  <div className="fw6">Objectives:</div>
                  <div>{call.call_objectives}</div>
                </div>
                {feedback.data && (
                  <div className="mb1">
                    <div className="fw6">Insider's feedback:</div>
                    <Stars
                      count={5}
                      size={16}
                      value={feedback.data.rate.value}
                      edit={false}
                      color="#ffd700"
                    />
                    {feedback.data.general_feedback && (
                      <div className="mt1">
                        {feedback.data.general_feedback}
                      </div>
                    )}
                  </div>
                )}
                {selfFeedback.data &&
                  !selfFeedback.data.completed && (
                    <React.Fragment>
                      <br />
                      <Link
                        to={
                          candidate.onInsiderFeedback +
                          `?booking_id=${call.id}&target_id=${call.insider.id}`
                        }
                      >
                        <Button size="small">
                          Rate the insider and unlock his feedback about you
                        </Button>
                      </Link>
                    </React.Fragment>
                  )}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Overlay>
  );
};



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/DashboardCall/View.js